import React from 'react';

import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import Overview from '../../pages/issuer/List/Overview';
import DisclosureRequirements from '../../pages/issuer/List/DisclosureRequirements';
import DocumentsTemplates from '../../pages/issuer/List/DocumentsTemplates';
import VerifiedPartners from '../../pages/issuer/List/VerifiedPartners';
import ListingDetails from '../../pages/issuer/List/ListingDetails';
import SponsorAdvisorUpdate from '../../pages/issuer/List/SponsorAdvisorUpdate';

import VerticalContainer from '../../components/VerticalContainer';

const ListRoutes = () => {
    let { path } = useRouteMatch();

    return (
        <VerticalContainer>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}/`} component={Overview} />
                    <Route
                        exact
                        path={`${path}/disclosure-requirements`}
                        component={DisclosureRequirements}
                    />

                    <Route
                        exact
                        path={`${path}/sponsor-advisor-updates`}
                        component={SponsorAdvisorUpdate}
                    />

                    <Route
                        exact
                        path={`${path}/documents-templates`}
                        component={DocumentsTemplates}
                    />
                    <Route
                        exact
                        path={`${path}/listing-details`}
                        component={ListingDetails}
                    />
                    <Route
                        exact
                        path={`${path}/verified-partners`}
                        component={VerifiedPartners}
                    />
                </Switch>
            </TabPanel>
        </VerticalContainer>
    );
};

export default ListRoutes;
